import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ButtonV2 from '../../../common/components/atom/ButtonV2/Button'
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import ZhagaNodeList from './components/ZhagaNodeList/ZhagaNodeList'
import AddZhagaNodeDialog from './components/AddZhagaNodeDialog/AddZhagaNodeDialog'
import ImportLuminaireCsvDialog from './components/ImportLuminaireCsvDialog/ImportLuminaireCsvDialog'
import { buildCsvTemplate, downloadCsv } from '../../../common/utils/csv'

export default function LuminairePage() {
  const [addDialogOpen, setAddDialogOpen] = useState(false)
  const [importDialogOpen, setImportDialogOpen] = useState(false)
  const navigate = useNavigate()

  const handleDownloadTemplate = () => {
    const csv = buildCsvTemplate(
      ['lum_dev_eui', 'lum_pole_number', 'lum_phase_number', 'lum_name'],
      [['0000000000000001', '12', '1', 'Luminaire exemple']],
    )
    downloadCsv('luminaire_template.csv', csv)
  }

  return (
    <div>
      <HeaderTitleContent>Luminaires</HeaderTitleContent>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '1.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <ButtonV2
          onClick={() => navigate('/main/setting')}
          variant="outlined"
          size="medium"
          color="secondary"
        >
          ← Retour
        </ButtonV2>
        <ButtonV2
          onClick={() => setAddDialogOpen(true)}
          variant="dashboard-btn-outlined"
          size="medium"
          color="secondary"
        >
          Ajouter un nœud Zhaga
        </ButtonV2>
        <ButtonV2
          onClick={() => setImportDialogOpen(true)}
          variant="dashboard-btn-outlined"
          size="medium"
          color="secondary"
        >
          Importer CSV
        </ButtonV2>
        <ButtonV2
          onClick={handleDownloadTemplate}
          variant="outlined"
          size="medium"
          color="secondary"
        >
          Télécharger le modèle
        </ButtonV2>
      </div>
      <ZhagaNodeList />
      <AddZhagaNodeDialog
        open={addDialogOpen}
        onClose={() => setAddDialogOpen(false)}
      />
      <ImportLuminaireCsvDialog
        open={importDialogOpen}
        onClose={() => setImportDialogOpen(false)}
      />
    </div>
  )
}
